import { Cuenta, CuentaForm, CuentaTable, CuentaUpsert } from '@core/models';
import { toKebabCase } from '../general.helper';
import { AccountStatus } from '@core/enums';
import { transformStateForm } from '../state/state-mapper';
import { transformContactDetailForm, transformContactDetailUpsert, transformLocationForm, transformLocationUpsert } from '..';

export function transformToData(
  account: Cuenta | null
): Cuenta | null {
  if (!account) return null;

  return {
    ...account,
    estadoId: account.estado?.idEstado,
  };
}

export function transformArrayToData(accounts: Cuenta[]): Cuenta[] {
  return (accounts ?? []).map((account) => transformToData(account)).filter((a) => !!a) ?? [];
}

export function transformToTable(
  account: Cuenta,
): CuentaTable {
  const {
    idCuenta,
    nombre,
    estado,
    ubicacion,
    datosContacto,
    fechaCreacion,
    count_locals,
    resellerId,
  } = account;

  return {
    idCuenta,
    nombre,
    direccion: ubicacion?.direccion,
    email: datosContacto?.email,
    fechaCreacion: fechaCreacion || '',
    status: estado.descripcion,
    active: estado.descripcion === AccountStatus.Active,
    cantidadLocales: count_locals || 0,
    resellerId,
  };
}

export function transformArrayToTable(accounts: Cuenta[]): CuentaTable[] {
  return (accounts ?? []).map((account) => transformToTable(account)).filter((a) => !!a) ?? [];
}

export function transformToForm(
  account: Cuenta
): CuentaForm {
  const {
    idCuenta: id,
    nombre: name,
    slug,
    usuario: username,
    imagen: image,
    estado: status,
    ubicacion,
    datosContacto,
    resellerId,
    estadoId: statusId,
  } = account;

  return {
    id,
    name,
    slug,
    username,
    image,
    status: transformStateForm(status),
    location: transformLocationForm(ubicacion),
    contactData: transformContactDetailForm(datosContacto),
    resellerId,
    statusId,
  };
}

export function transformArrayToForm(accounts: Cuenta[]): CuentaForm[] {
  return (accounts ?? []).map((account) => transformToForm(account)).filter((l) => !!l) ?? [];
}

export function transformToUpsert(
  accountForm: CuentaForm
): CuentaUpsert {

  const {
    name: nombre,
    location,
    image: imagen,
    contactData,
    resellerId,
    statusId: estado,
  } = accountForm;

  const payload = {
    nombre,
    slug: toKebabCase(nombre),
    imagen,
    estado,
    ubicacion: transformLocationUpsert(location),
    datosContacto: transformContactDetailUpsert(contactData),
    resellerId,
  }

  if (!(imagen instanceof File))
    delete payload.imagen;

  return payload;
}

export function transformArrayToUpsert(accounts: CuentaForm[]): CuentaUpsert[] {
  return (accounts ?? []).map((account) => transformToUpsert(account)).filter((l) => !!l) ?? [];
}